/* [Directives] */
import clickOutside from "./clickOutside"
import urTooltip    from "./urTooltip"
import urAttachRoot from "./urAttachRoot"

export default function install(Vue){
    Vue.use(clickOutside);
    Vue.use(urTooltip);
    Vue.use(urAttachRoot);
};
